import { hobbies } from "./hobbies"
import { professional } from "./professional"
import { programs } from "./programs"
import { introApplets } from "./welcome"

export const applets = [professional, hobbies, programs, introApplets].flat(1)